import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'apiHandlerReady',
  initialState: false,
  reducers: {
    setApiHandlerReady() {
      return true;
    },
  },
});

export const { setApiHandlerReady } = slice.actions;

export default slice.reducer;
